import { Box, Container, Grid, useMediaQuery } from "@mui/material";
import React from "react";
import logo from "../images/logo1.png";
import telegram from "../images/telegram.svg";
import twitter from "../images/twitter.svg";
import medium from "../images/Mail.svg";

export default function Footer() {
  const matches = useMediaQuery("(max-width:750px)");

  return (
    <Box py={5} borderTop="0.5px solid #ffffff">
      <Container maxWidth="lg">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm={6}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems={matches ? "center" : "flex-start"}
            >
              <Box>
                <a href="https://galaxypad.io">
                  <img src={logo} alt="logo-galaxy-pad" />
                </a>
              </Box>
              <Box fontFamily="Raleway">
                © 2022 GalaxyPad, all rights reserved
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={matches ? "center" : "flex-end"}
              mt={matches ? 3 : 0}
            >
              <a
                style={{ marginRight: "20px" }}
                target="_blank"
                href="https://t.me/galaxypadofficial/"
              >
                <img src={telegram} alt="telegram" />
              </a>
              <a
                style={{ marginRight: "20px" }}
                target="_blank"
                href="https://twitter.com/galaxypadtoken/"
              >
                <img src={twitter} alt="twitter" />
              </a>
              <a target="_blank" href="https://medium.com/@galaxypadofficial/">
                <img src={medium} alt="Mail" />
              </a>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
